import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/OrderType/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/OrderType/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/OrderType/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/OrderType/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/OrderType/Delete',
    method: 'delete',
    data,
  })
}

export function fetchAll() {
  return request({
    url: '/OrderType/List',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}
